import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';
import { Box, useMediaQuery } from '@mui/material';

// @import Images
import authFrame1 from '@assets/images/auth-frame-1.png';
import authFrame2 from '@assets/images/auth-frame-2.png';
import authFrame3 from '@assets/images/auth-frame-3.png';

export const WriterlyAuthLayout = ({ leftContent }) => {
  const mobileView = useMediaQuery('(max-width: 834px)');
  const { pathname } = useLocation();
  return (
    <div className="flex w-full h-screen">
      <div
        className={`w-full flex items-center justify-center overflow-auto z-40`}
        data-testid={'auth-leftContent'}
      >
        {leftContent}
      </div>

      <Box className="absolute bottom-0 w-full z-30 overflow-hidden">
        <Box className="top-0 w-full flex justify-between">
          <img src={authFrame1} alt="curve-signup-left" />
          <img src={authFrame2} alt="curve-signup-right" />
        </Box>
      </Box>
      <Box className="absolute w-full z-20">
        <Box className="w-full flex justify-end -mt-60 backdrop-blur-3xl transition-all">
          <img
            src={authFrame3}
            alt="curve-signup-center"
            className="backdrop-blur-md"
          />
        </Box>
      </Box>
    </div>
  );
};

WriterlyAuthLayout.propTypes = {
  leftContent: PropTypes.node,
  rightContent: PropTypes.node,
  customImage: PropTypes.string,
};
